export function triggerProgrammaticDownload(url: string, suggestedFilename: string) {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = suggestedFilename;
  anchor.rel = 'noopener noreferrer';
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
